let cartUpdateType = 'none';
let globalPromoProductId = null;
let globalPromoProductKey = null;

function enableLoading() {
  const preloader = document.querySelector('cart-drawer .cart-preloader');
  if (preloader) {
    preloader.classList.remove('hidden-el');
  }
}

function disableLoading() {
  const preloader = document.querySelector('cart-drawer .cart-preloader');
  if (preloader) {
    preloader.classList.add('hidden-el');
  }
}

function updatePromoThreshold() {
  console.log('updatePromoThreshold function called');

  const promoSection = document.querySelector('promo-section');
  if (!promoSection || !promoSection.dataset.enabled || promoSection.dataset.enabled !== 'true') {
    console.log('Promo section is not enabled or not present.');
    return;
  }

  const promoThresholdElement = document.getElementById('promo-threshold');
  const promoThresholdValue = parseFloat(promoThresholdElement.value);
  const currency = promoThresholdElement.getAttribute('data-currency');
  const cartTotal = parseFloat(promoThresholdElement.getAttribute('data-cart'));

  if (Shopify.currency.active !== 'USD') {
    const convertedPromoThreshold = Currency.convert(promoThresholdValue, "USD", Shopify.currency.active);

    const promoThresholdConvertedElement = document.getElementById('promo-threshold-converted');
    promoThresholdConvertedElement.value = convertedPromoThreshold;

    const checkoutButton = document.querySelector('.cart-checkout-button');
    const tooltipSpan = document.querySelector('.tooltip-message');

    fetch('/cart.js')
      .then(response => response.json())
      .then(cartData => {
        const promoItemInputs = document.querySelectorAll('.promo-item input');
        const promoItemIds = Array.from(promoItemInputs).map(input => parseInt(input.value, 10));
        const promoItemInCart = cartData.items.some(item => promoItemIds.includes(item.variant_id));

        if (cartTotal < convertedPromoThreshold) {
          promoSection.classList.add('visually-hidden');
          if (checkoutButton) {
            checkoutButton.removeAttribute('disabled');
            checkoutButton.setAttribute('href', '/checkout');
          }
          if (tooltipSpan) {
            tooltipSpan.classList.add('visually-hidden');
          }
        } else if (cartTotal >= convertedPromoThreshold && promoItemInCart) {
          promoSection.classList.remove('visually-hidden');
          if (checkoutButton) {
            checkoutButton.removeAttribute('disabled');
            checkoutButton.setAttribute('href', '/checkout');
          }
          if (tooltipSpan) {
            tooltipSpan.classList.add('visually-hidden');
          }
        } else if (cartTotal >= convertedPromoThreshold && !promoItemInCart) {
          promoSection.classList.remove('visually-hidden');
          if (checkoutButton) {
            checkoutButton.setAttribute('disabled', 'disabled');
            checkoutButton.setAttribute('href', '#');
          }
          if (tooltipSpan) {
            tooltipSpan.classList.remove('visually-hidden');
          }
        }
      })
      .catch(error => {
        console.error('Error fetching cart data:', error);
      });
  }
}

class PairWithItem extends HTMLElement {
  constructor() {
    super();
    this.initialized = false;
  }

  connectedCallback() {
    if (!this.initialized) {
      this.initialized = true;
      this.initializeAddButton();
    }
  }

  initializeAddButton() {
    const addButton = this.querySelector(".pair-with-add");
    if (addButton && !addButton.dataset.initialized) {
      addButton.addEventListener("click", this.handleAddClick.bind(this));
      addButton.dataset.initialized = true;
    }
  }

  handleAddClick(event) {
    const button = event.target;
    const productId = button.dataset.productId;
    this.addPairWithProduct(productId);
  }

  addPairWithProduct(id) {
    const body = JSON.stringify({
      items: [{
        id: id,
        quantity: 1
      }],
    });

    enableLoading();
    cartUpdateType = 'add';

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        'Content-Type': 'application/json'
      },
      body: body
    })
    .then((response) => response.json())
    .then((state) => {
      document.querySelector('cart-drawer').render(state).then(() => {
      });
    })
    .catch((error) => {
      console.error('Error adding pair-with product:', error);
    });
  }
}

customElements.define('pair-with-item', PairWithItem);

document.addEventListener("DOMContentLoaded", function() {
  const pairWithElements = document.querySelectorAll('pair-with-item');
  pairWithElements.forEach(pairWithElement => {
    if (pairWithElement) {
      pairWithElement.initializeAddButton();
    }
  });
});

class PromoSection extends HTMLElement {
  constructor() {
    super();
    this.scrollPosition = 0;
    this.debounceTimeout = null;
    this.initializePromoRadios();
  }

  connectedCallback() {
    if (!this.initialized) {
      this.initialized = true;
      this.initializePromoRadios();
    }
  }

  initializePromoRadios() {
    this.radioButtons = this.querySelectorAll('.promo-radio');

    this.radioButtons.forEach(radio => {
      radio.addEventListener('change', this.handleRadioChange.bind(this));
    });
  }

  handleRadioChange(event) {
    clearTimeout(this.debounceTimeout);
    this.debounceTimeout = setTimeout(() => {
      this.processRadioChange(event);
    }, 300);
  }

  processRadioChange(event) {
    this.saveScrollPosition();

    const selectedProductId = event.target.value;

    const cartDrawer = document.querySelector('cart-drawer');
    enableLoading();

    this.removePromoProduct(cartDrawer, selectedProductId)
      .then(() => {
        this.addPromoProduct(selectedProductId);
      })
      .catch(error => {
        disableLoading();
      });
  }

  removePromoProduct(cartDrawer, excludeProductId) {
    return cartDrawer.fetchCart().then(cartData => {
      const promoProductIds = Array.from(this.radioButtons).map(radio => radio.value);
      const promoProductInCart = cartData.items.find(item => promoProductIds.includes(String(item.id)) && String(item.id) !== excludeProductId);

      if (promoProductInCart) {
        const body = JSON.stringify({ id: promoProductInCart.key, quantity: 0 });

        return fetch("/cart/change.js", {
          method: "POST",
          headers: { 'Content-Type': 'application/json' },
          body: body
        }).then(response => response.json())
          .then(state => {
          });
      } else {
        return Promise.resolve();
      }
    });
  }

  addPromoProduct(productId) {
    const body = JSON.stringify({
      items: [{ id: productId, quantity: 1 }],
    });

    fetch("/cart/add.js", {
      method: "POST",
      headers: { 'Content-Type': 'application/json' },
      body: body
    })
    .then(response => response.json())
    .then(state => {
      globalPromoProductId = productId;

      const addedItem = state.items.find(item => item.id == productId);
      if (addedItem) {
        globalPromoProductKey = addedItem.key;
      }

      return document.querySelector('cart-drawer').render(state);
    })
    .then(() => {
      this.restoreScrollPosition();
      disableLoading();
    })
    .catch(error => {
      console.error('Error adding promo product:', error);
      disableLoading();
    });
  }

  saveScrollPosition() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      this.scrollPosition = cartDrawer.querySelector('.cart-scroll').scrollTop;
    }
  }

  restoreScrollPosition() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      cartDrawer.querySelector('.cart-scroll').scrollTop = this.scrollPosition;
    }
  }
}

customElements.define('promo-section', PromoSection);

document.addEventListener("DOMContentLoaded", function() {
  const promoElement = document.querySelector('promo-section');
  if (promoElement) {
    promoElement.initializePromoRadios();
  }
});

class CartSamples extends HTMLElement {
  constructor() {
    super();

    this.checkboxes = this.querySelectorAll(".cart-minis input");
    this.cartDrawer = this.closest('cart-drawer');
    this.debounceTimeout = null;

    this.checkboxes.forEach(checkbox => {
      checkbox.addEventListener('click', this.onChange.bind(this));
    });

    this.max = 2;
    this.checkboxAbilities();
  }

  connectedCallback() {
    if (!this.initialized) {
      this.initialized = true;
      this.checkboxes = this.querySelectorAll(".cart-minis input");
      this.cartDrawer = this.closest('cart-drawer');

      this.checkboxes.forEach(checkbox => {
        checkbox.addEventListener('click', this.onChange.bind(this));
      });

      this.max = 2;
      this.checkboxAbilities();
    }
  }

  disconnectedCallback() {
    this.initialized = false;
  }

  onChange(event) {
    clearTimeout(this.debounceTimeout);
    this.debounceTimeout = setTimeout(() => { 
      this.processChange(event);
    }, 300);
  }

  processChange(event) {
    const checkbox = event.target;
    const productId = checkbox.value;
    

    if (checkbox.checked) {
      this.addSample(productId);
    } else {
      this.removeSample(productId);
    }
    this.checkboxAbilities();
  }

  checkboxAbilities() {
    const checkboxes = Array.from(this.querySelectorAll("input[type=checkbox]"));
    const totalCheckedValue = this.checkedValue();

    checkboxes.forEach(checkbox => {
      if (checkbox.checked) {
        return;
      }

      const value = Number(checkbox.dataset.checkedValue);

      if ((totalCheckedValue + value) > this.max) {
        checkbox.disabled = true;
      } else {
        checkbox.disabled = false;
      }
    });
  }

  addSample(id) {
  
    const body = JSON.stringify({
      items: [{
        id: id,
        quantity: 1
      }],
    });

    this.saveScrollPosition();
    enableLoading();
  
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        'Content-Type': 'application/json'
      },
      body: body
    })
    .then((response) => response.json())
    .then((state) => {
      document.querySelector('cart-drawer').render(state).then(() => {
        disableLoading();
        this.restoreScrollPosition();
      });
    })
    .catch((error) => {
      console.error('Error adding sample:', error);
    });
  }

  removeSample(id) {
    enableLoading();  

    const body = JSON.stringify({
      id: id,
      quantity: 0,
    });

    this.saveScrollPosition();

    fetch("/cart/change.js", {
      method: "POST",
      headers: {
        'Content-Type': 'application/json'
      },
      body: body
    }).then((response) => {
      return response.json();
    }).then((state) => {
      this.cartDrawer.render(state).then(() => {
        this.restoreScrollPosition();
      });
    }).catch((error) => {
      console.error('Error removing sample:', error);
      disableLoading();
    });
  }

  saveScrollPosition() {
    this.scrollPosition = this.cartDrawer.querySelector('.cart-scroll').scrollTop;
  }

  restoreScrollPosition() {
    this.cartDrawer.querySelector('.cart-scroll').scrollTop = this.scrollPosition;
  }

  checkedValue() {
    var checkedInputs = this.querySelectorAll(".cart-minis input:checked");
    var checkedValue = Array.from(checkedInputs)
      .map(element => Number(element.dataset.checkedValue))
      .reduce((a, b) => a + b, 0);

    return checkedValue;
  }
}

customElements.define('cart-samples', CartSamples);

document.addEventListener("DOMContentLoaded", () => {
  const cartSamplesElement = document.querySelector('cart-samples');
if (cartSamplesElement) {
  cartSamplesElement.checkboxes = cartSamplesElement.querySelectorAll(".cart-minis input");
  cartSamplesElement.cartDrawer = cartSamplesElement.closest('cart-drawer');
  
  cartSamplesElement.checkboxes.forEach(checkbox => {
    checkbox.addEventListener('click', cartSamplesElement.onChange.bind(cartSamplesElement));
  });

  cartSamplesElement.max = 2;
  cartSamplesElement.checkboxAbilities();
}
});

class GiftBox extends HTMLElement {
  constructor() {
    super();
    this.giftBoxingProductId = 812526797;
    console.log('GiftBox component initialized');
  }

  connectedCallback() {
    if (!this.initialized) {
      this.initialized = true;
      this.cartDrawer = this.closest('cart-drawer');
      console.log('GiftBox connected to cart-drawer');
      this.initializeGiftCheckbox();
      this.initializeGiftNoteFields();
    }
  }

  disconnectedCallback() {
    this.initialized = false;
    console.log('GiftBox disconnected');
  }

  initializeGiftCheckbox() {
    const cartGiftBoxingCheckbox = this.querySelector("#cart-gift-boxing");
    if (cartGiftBoxingCheckbox) {
      cartGiftBoxingCheckbox.addEventListener("change", this.handleGiftBoxingChange.bind(this));
      console.log('Gift checkbox initialized');
    }
  }

  handleGiftBoxingChange(event) {
    const cartGiftBoxingCheckbox = event.target;
    console.log('Gift boxing checkbox changed:', cartGiftBoxingCheckbox.checked);
    if (cartGiftBoxingCheckbox.checked) {
      this.addGiftBox();
    } else {
      this.removeGiftBox();
    }
    this.expandGiftNoteFields(cartGiftBoxingCheckbox.checked);
  }

  addGiftBox() {
    const restrictedProductIds = [1687467163737, 1687442587737, 6056491450555, 2016087801945];
    console.log('Adding gift box');

    if (this.cartDrawer) {
      this.cartDrawer.fetchCart().then(cartData => {
        const cartProductIds = cartData.items.filter(item => {
          return item.line_price > 0;
        }).map(item => item.product_id);

        const hasOnlyRestrictedProducts = cartProductIds.every(product_id => restrictedProductIds.includes(product_id));

        if (hasOnlyRestrictedProducts) {
          console.log('Only restricted products in cart, not adding gift box');
          return;
        }

        const body = JSON.stringify({
          items: [{
            id: this.giftBoxingProductId,
            quantity: 1
          }]
        });

        this.saveScrollPosition();

        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            'Content-Type': 'application/json'
          },
          body: body
        })
        .then((response) => response.json())
        .then((state) => {
          console.log('Gift box added to cart');
          document.querySelector('cart-drawer').render(state).then(() => {
            this.restoreScrollPosition();
          });
        })
        .catch((error) => {
          console.error("Error adding gift boxing product:", error);
        });
      });
    }
  }

  removeGiftBox() {
    console.log('Removing gift box');
    this.cartDrawer.fetchCart().then(cartData => {
        const giftBoxItem = cartData.items.find(item => item.id === this.giftBoxingProductId);
        
        if (!giftBoxItem) {
            console.log('Gift box not found in cart, clearing gift note');
            this.clearGiftNote();
            return;
        }

        const body = JSON.stringify({
            id: "812526797",
            quantity: 0,
        });

        this.saveScrollPosition();

        fetch("/cart/change.js", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: body
        }).then((response) => {
            return response.json();
        }).then((state) => {
            console.log('Gift box removed from cart');
            this.cartDrawer.render(state).then(() => {
                this.restoreScrollPosition();
                setTimeout(() => {
                    this.clearGiftNote();
                }, 300);
            });
        }).catch((error) => {
            console.error('Error removing gift boxing product:', error);
        });
    });
  }

  clearGiftNote() {
    console.log('Fetching current cart note');
    Shopify.getCart((cart) => {
      console.log('Current cart note before clearing:', cart.note);
      const note = "";
      console.log('Clearing gift note:', note);
      Shopify.updateCartNote(note, (updatedCart) => {
        console.log('Gift note cleared. Updated cart note:', updatedCart.note);
        this.clearGiftNoteFields();
      });
    });
  }

  clearGiftNoteFields() {
    const giftToField = this.querySelector("#gift-to");
    const giftFromField = this.querySelector("#gift-from");
    const giftMessageField = this.querySelector("#gift-message");

    if (giftToField) giftToField.value = "";
    if (giftFromField) giftFromField.value = "";
    if (giftMessageField) giftMessageField.value = "";

    console.log('Gift note fields cleared');
  }

  expandGiftNoteFields(shouldExpand) {
    const cartNoteForm = this.querySelector(".cart-note-checkbox-form");
    if (cartNoteForm) {
      if (shouldExpand) {
        cartNoteForm.classList.add("show");
        setTimeout(() => {
          this.scrollToElement(cartNoteForm);
        }, 300);
      } else {
        cartNoteForm.classList.remove("show");
      }
    }
  }

  scrollToElement(element) {
    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  
  saveScrollPosition() {
    if (this.cartDrawer) {
      this.scrollPosition = this.cartDrawer.querySelector('.cart-scroll').scrollTop;
      console.log('Scroll position saved:', this.scrollPosition);
    }
  }

  restoreScrollPosition() {
    if (this.cartDrawer) {
      const offset = 450;
      this.cartDrawer.querySelector('.cart-scroll').scrollTop = this.scrollPosition + offset;
      console.log('Scroll position restored:', this.scrollPosition + offset);
    }
  }

  initializeGiftNoteFields() {
    const giftToField = this.querySelector("#gift-to");
    const giftFromField = this.querySelector("#gift-from");
    const giftMessageField = this.querySelector("#gift-message");

    if (giftToField && giftFromField && giftMessageField) {
      giftToField.addEventListener("keyup", this.debounce(this.handleGiftNoteChange.bind(this), 250));
      giftFromField.addEventListener("keyup", this.debounce(this.handleGiftNoteChange.bind(this), 250));
      giftMessageField.addEventListener("keyup", this.debounce(this.handleGiftNoteChange.bind(this), 250));
      console.log('Gift note fields initialized');
    }
  }

  handleGiftNoteChange() {
    const giftTo = this.querySelector("#gift-to").value || "";
    const giftFrom = this.querySelector("#gift-from").value || "";
    const giftMessage = this.querySelector("#gift-message").value || "";
    const note = `To: ${giftTo}, From: ${giftFrom}, Message: ${giftMessage}`;

    console.log('Gift note changed:', note);
    Shopify.updateCartNote(note, function (cart) {
      console.log('Gift note updated in cart:', cart.note);
    });
  }

  debounce(func, wait) {
    let timeout;
    return function () {
      const context = this, args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), wait);
    };
  }
}

customElements.define('gift-box', GiftBox);

document.addEventListener("DOMContentLoaded", () => {
  const giftBoxElement = document.querySelector('gift-box');
  if (giftBoxElement) {
    giftBoxElement.initializeGiftCheckbox();
    giftBoxElement.initializeGiftNoteFields();
  }
});

function initializeSlickSlider() {
  if ($('.pair-with__container').hasClass('slick-initialized')) {
    $('.pair-with__container').slick('unslick');
  }

  $('.pair-with__container').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    infinite: false,
    initialSlide: 0,
    variableWidth: true,
  });
}

function updateShippingDescription() {
  const shippingDescriptionUS = document.querySelector('.shipping-description-us');
  const shippingDescriptionInternational = document.querySelector('.shipping-description-international');

  function setShippingDescription(country) {
    if (country === 'US') {
      if (shippingDescriptionUS) {
        shippingDescriptionUS.classList.add('show');
        shippingDescriptionUS.classList.remove('hide');
      }
      if (shippingDescriptionInternational) {
        shippingDescriptionInternational.classList.add('hide');
        shippingDescriptionInternational.classList.remove('show');
      }
    } else {
      if (shippingDescriptionUS) {
        shippingDescriptionUS.classList.add('hide');
        shippingDescriptionUS.classList.remove('show');
      }
      if (shippingDescriptionInternational) {
        shippingDescriptionInternational.classList.add('show');
        shippingDescriptionInternational.classList.remove('hide');
      }
    }
  }

  const initialCountry = Shopify.country || 'International';
  setShippingDescription(initialCountry);

  geoip2.country(function(response) {
    const geoipCountry = response.country.iso_code;

    if (geoipCountry === 'US' && Shopify.country === 'US') {
      setShippingDescription('US');
    } else {
      setShippingDescription('International');
    }
  });
}


document.addEventListener("DOMContentLoaded", function () {

  if (!window.addedCartListeners) {
    window.addedCartListeners = true;

    document.addEventListener("addtocart", function (event) {
        cartUpdateType = 'add';
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
            enableLoading();
            cartDrawer.render()
              .then(() => {
                disableLoading();
              })
              .catch(error => {
                console.error('Error rendering cart drawer:', error);
                disableLoading();
              });
        }
    });
}
  

   updateShippingDescription();


   class CartDrawer extends HTMLElement {
    constructor() {
      super();
      this.scrollPosition = 0;
      this.preloader = this.querySelector('.cart-preloader');
      this.show = this.debounce(this.show.bind(this), 200);
    }
  
    connectedCallback() {
      if (!this.initialized) {
        this.initialized = true;
  
        
        document.addEventListener("cartlink:click", () => {
          this.show();
        });
  
        
        if (theme.URLParams.has("cart")) {
          if (!this.classList.contains("state--active")) {
            this.show();
          }
        }
      }
    }
  
    debounce(func, wait) {
      let timeout;
      return function() {
        const context = this, args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), wait);
      };
    }
  
    show() {
      setTimeout(() => {
        this.classList.add("state--active");
        this.updateURLWithCartParam(true);
      }, 50);
    }
  
    hide() {
      this.classList.remove("state--active");
      this.updateURLWithCartParam(false);
    }
  
    updateURLWithCartParam(isCartOpen) {
      const url = new URL(window.location);
      if (isCartOpen) {
        url.searchParams.set('cart', 'true');
      } else {
        url.searchParams.delete('cart');
      }
      window.history.replaceState({}, '', url);
    }
  
    async change(data) {
      try {
        const response = await fetch("/cart/change.js", {
          method: "POST",
          headers: {
            'Content-Type': "application/json"
          },
          body: JSON.stringify(data)
        });
        return await response.json();
      } catch (error) {
        console.error('Error changing cart item:', error);
      }
    }
  
    async fetchCart() {
      try {
        const response = await fetch("/cart.js");
        const cartData = await response.json();
        return cartData;
      } catch (error) {
        console.error('Error fetching cart:', error);
      }
    }
  
    async render() {
      const current_content = document.getElementById("cart-content");
      const stackContainer = current_content ? current_content.querySelector('.stack--1') : null;
  
      this.scrollPosition = stackContainer ? stackContainer.scrollTop : 0;
  
      function get_new_content(response) {
        const string = JSON.parse(response)["cart-drawer"];
        const parser = new DOMParser();
        const doc = parser.parseFromString(string, "text/html");
  
        return doc.getElementById("cart-content");
      }
  
      try {
        const response = await fetch("/?sections=cart-drawer");
        const text = await response.text();
        current_content.replaceWith(get_new_content(text));
        
        updatePromoThreshold();
        updateSubheadingMaxWidth();
        initializeSlickSlider();
        updateShippingDescription();
  
        const newStackContainer = document.getElementById("cart-content") ? document.getElementById("cart-content").querySelector('.stack--1') : null;
        if (cartUpdateType === 'add' || cartUpdateType === 'remove') {
          setTimeout(() => {
            const pairWithWrapper = document.querySelector('.pair-with-wrapper');
            const cartMinisWrapper = document.querySelector('cart-samples');
            const cartItems = document.querySelector('.cart-items');
  
            if (pairWithWrapper) {
              pairWithWrapper.scrollIntoView({ behavior: 'smooth', block: 'end' });
            } else if (cartMinisWrapper) {
              cartItems.scrollIntoView({ behavior: 'smooth', block: 'end' });
            } else {
              if (newStackContainer) {
                newStackContainer.scrollTop = this.scrollPosition;
              }
            }
          }, 300);
        } else {
          if (newStackContainer) {
            newStackContainer.scrollTop = this.scrollPosition;
          }
        }
  
        cartUpdateType = 'none';
  
      } catch (error) {
        console.error('Error rendering cart drawer:', error);
      }
    }
  }
  
  customElements.define("cart-drawer", CartDrawer);

  class CartItemRemove extends HTMLElement {
    constructor() {
      super();
      this.giftBoxingProductId = 334827469;
      this.giftBoxedProductIds = [];
      this.initializeGiftBoxVariables();
      this.rebind();
    }
  
    initializeGiftBoxVariables() {
      const idsInput = document.getElementById("giftboxed_product_ids");
      const fallbackGiftBoxedProductIds = [1687467163737, 1687442587737, 6056491450555, 2016087801945];
  
      if (idsInput && idsInput.value.trim() !== "") {
        this.giftBoxedProductIds = idsInput.value.split(",").map(Number);
        console.log("GiftBoxed Product IDs initialized from input:", this.giftBoxedProductIds);
      } else {
        this.giftBoxedProductIds = fallbackGiftBoxedProductIds;
        console.log("GiftBoxed Product IDs fallback assigned:", this.giftBoxedProductIds);
      }
    }
  
    rebind() {
      const CartDrawer = this.closest("cart-drawer");
  
      if (!CartDrawer) return;
  
      const key = this.getAttribute("key");
  
      if (!key) return;
  
      const data = { id: key, quantity: 0 };
  
      this.addEventListener("click", async (event) => {
        event.preventDefault();
        console.log("Removing cart item, key:", key);
  
        enableLoading();
        cartUpdateType = "remove";
  
        try {
          const cartData = await CartDrawer.fetchCart();
          const itemToRemove = cartData.items.find((item) => item.key === key);
          console.log("Item to remove:", itemToRemove);
  
          const updatedCartData = await CartDrawer.change(data);
          console.log("Item removed, updated cart data:", updatedCartData);
  
          const removalUpdates = {};
          const asyncOperations = [];
  
          const isGiftBoxPresent = updatedCartData.items.some(item => item.product_id === this.giftBoxingProductId);
          const remainingItems = updatedCartData.items.filter(item => item.line_price > 0 && item.product_id !== this.giftBoxingProductId);
          const restrictedProducts = remainingItems.filter(item => this.giftBoxedProductIds.includes(item.product_id)).length;
  
          if (isGiftBoxPresent && remainingItems.length === restrictedProducts && restrictedProducts > 0) {
            console.log("Conditions met for removing gift box.");
            const giftBoxItem = updatedCartData.items.find(item => item.product_id === this.giftBoxingProductId);
            if (giftBoxItem) {
              removalUpdates[giftBoxItem.key] = 0;
              asyncOperations.push(this.clearGiftNote());
            }
          }
  
          const sampleQualifyingProductsInput = document.getElementById("samples_qualifying_products").value;
          const sampleQualifyingProducts = sampleQualifyingProductsInput.split(",").map((product) => product.trim());
          const remainingSampleQualifyingItems = updatedCartData.items.filter((item) => sampleQualifyingProducts.includes(item.handle));
  
          if (remainingSampleQualifyingItems.length === 0) {
            console.log("No remaining sample-qualifying items. Removing samples.");
            const sampleInputs = document.querySelectorAll(".cart-minis input");
            sampleInputs.forEach((input) => {
              const sampleId = input.value;
              const sampleInCart = updatedCartData.items.find((item) => item.variant_id == sampleId);
              if (sampleInCart) {
                removalUpdates[sampleInCart.key] = 0;
              }
            });
          }
  
          const promoSection = document.querySelector('promo-section');
          const promoProductIds = Array.from(promoSection?.querySelectorAll('.promo-radio') || []).map(radio => radio.value);
          const promoProductInCart = updatedCartData.items.find(item => promoProductIds.includes(String(item.id)));
  
          if (this.isBelowPromoThreshold(updatedCartData) && promoProductInCart) {
            console.log("Cart is below promo threshold, removing promo product.");
            removalUpdates[promoProductInCart.key] = 0;
          }

          const remainingCartItems = updatedCartData.items.filter(
            (item) => !removalUpdates.hasOwnProperty(item.key)
          );
        
          // Log remaining cart items after planned removals
          console.log("Remaining cart items after planned removals:", remainingCartItems);
        
          if (remainingCartItems.length === 1) {
            console.log(
              "One remaining item detected. Checking if it is the gift box."
            );
        
            if (remainingCartItems[0].product_id === this.giftBoxingProductId) {
              console.log("Gift box will be the only item left after removals, adding to updates.");
              removalUpdates[remainingCartItems[0].key] = 0;
              asyncOperations.push(this.clearGiftNote());
        
              // Log the updated removalUpdates object
              console.log("Updated removalUpdates with gift box removal:", removalUpdates);
            } else {
              console.log(
                "The remaining item is not the gift box. Remaining item product ID:",
                remainingCartItems[0].product_id
              );
            }
          } else {
            console.log(
              `Multiple items remain in the cart (${remainingCartItems.length}). No action taken for gift box.`
            );
          }
  
          if (Object.keys(removalUpdates).length > 0) {
            // Log current state of removal updates and cart data
            console.log("Current removal updates:", removalUpdates);
          
            asyncOperations.push(
              this.additionalCartUpdates(removalUpdates)
                .then(() => {
                  console.log("Additional cart updates completed successfully.");
                })
                .catch((error) => {
                  console.error("Error during additional cart updates:", error);
                })
            );
          }
  
          await Promise.all(asyncOperations);
          await CartDrawer.render();
          disableLoading();
  
        } catch (error) {
          console.error("Error during CartItemRemove flow:", error);
          disableLoading();
        }
      });
    }
  
    async additionalCartUpdates(updates) {
      const body = JSON.stringify({ updates });
  
      console.log("Sending API request to perform additional cart updates:", updates);
  
      try {
        const response = await fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body,
        });
  
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
  
        const updatedCartData = await response.json();
        console.log("Cart updated successfully. New cart state:", updatedCartData);
  
        return updatedCartData;
      } catch (error) {
        console.error("Error updating cart quantities:", error);
        throw error;
      }
    }
  
    async clearGiftNote() {
      console.log("Clearing gift note.");
      return new Promise((resolve, reject) => {
        Shopify.getCart((cart) => {
          const note = "";
          Shopify.updateCartNote(note, (updatedCart) => {
            console.log("Gift note cleared. Updated cart note:", updatedCart.note);
            resolve(updatedCart);
          });
        });
      });
    }
  
    isBelowPromoThreshold(cartData) {
      const promoThresholdElement = document.getElementById("promo-threshold-converted");
      const promoThreshold = promoThresholdElement ? parseInt(promoThresholdElement.value, 10) : 0;
  
      let totalExcludingGiftCards = cartData.total_price;
      cartData.items.forEach((item) => {
        if (item.product_type === "Gift Card" || item.sku === "GFT100") {
          totalExcludingGiftCards -= item.price;
        }
      });
  
      const isBelowThreshold = totalExcludingGiftCards <= promoThreshold;
  
      console.log("Checking if cart is below promo threshold:");
      console.log("Promo threshold:", promoThreshold);
      console.log("Cart total:", cartData.total_price);
      console.log("Total excluding gift cards:", totalExcludingGiftCards);
      console.log("Is below threshold:", isBelowThreshold);
  
      return isBelowThreshold;
    }
  }
  
  customElements.define("cart-item-remove", CartItemRemove);
  
  class CartItemQuantity extends HTMLElement {
    constructor() {
      super();
      this.giftBoxingProductId = 334827469;
      this.giftBoxedProductIds = [];
      this.initializeGiftBoxVariables();
      this.rebind();
    }
  
    initializeGiftBoxVariables() {
      const idsInput = document.getElementById("giftboxed_product_ids");
      const fallbackGiftBoxedProductIds = [1687467163737, 1687442587737, 6056491450555, 2016087801945];
  
      if (idsInput && idsInput.value.trim() !== "") {
        this.giftBoxedProductIds = idsInput.value.split(",").map(Number);
        console.log("GiftBoxed Product IDs initialized from input:", this.giftBoxedProductIds);
      } else {
        this.giftBoxedProductIds = fallbackGiftBoxedProductIds;
        console.log("GiftBoxed Product IDs fallback assigned:", this.giftBoxedProductIds);
      }
    }
  
    rebind() {
      const CartDrawer = this.closest("cart-drawer");
      if (!CartDrawer) return;
  
      const key = this.getAttribute("key");
      const quantity = Number(this.getAttribute("quantity"));
      let data = { id: key, quantity: quantity };
  
      this.addEventListener("click", async (event) => {
        if (event.target.nodeName === "BUTTON") {
          data.quantity += Number(event.target.dataset.increment);
          console.log("Changing item quantity, key:", key, "New quantity:", data.quantity);
  
          enableLoading();
  
          try {
            const updatedCartData = await CartDrawer.change(data);
            console.log("Quantity updated, cart data:", updatedCartData);
  
            const removalUpdates = {};
            const asyncOperations = [];
  
            const isGiftBoxPresent = updatedCartData.items.some(
              (item) => item.product_id === this.giftBoxingProductId
            );
            const remainingItems = updatedCartData.items.filter(
              (item) => item.line_price > 0 && item.product_id !== this.giftBoxingProductId
            );
            const restrictedProducts = remainingItems.filter((item) =>
              this.giftBoxedProductIds.includes(item.product_id)
            ).length;
  
            if (isGiftBoxPresent && remainingItems.length === restrictedProducts && restrictedProducts > 0) {
              console.log("Conditions met for removing gift box.");
              const giftBoxItem = updatedCartData.items.find(
                (item) => item.product_id === this.giftBoxingProductId
              );
              if (giftBoxItem) {
                removalUpdates[giftBoxItem.key] = 0;
                asyncOperations.push(this.clearGiftNote());
              }
            }
  
            const sampleQualifyingProductsInput = document.getElementById("samples_qualifying_products").value;
            const sampleQualifyingProducts = sampleQualifyingProductsInput.split(",").map((product) => product.trim());
            const remainingSampleQualifyingItems = updatedCartData.items.filter((item) =>
              sampleQualifyingProducts.includes(item.handle)
            );
  
            if (remainingSampleQualifyingItems.length === 0) {
              console.log("No remaining sample-qualifying items. Removing samples.");
              const sampleInputs = document.querySelectorAll(".cart-minis input");
              sampleInputs.forEach((input) => {
                const sampleId = input.value;
                const sampleInCart = updatedCartData.items.find(
                  (item) => item.variant_id == sampleId
                );
                if (sampleInCart) {
                  removalUpdates[sampleInCart.key] = 0;
                }
              });
            }
  
            const promoSection = document.querySelector("promo-section");
            const promoProductIds = Array.from(
              promoSection?.querySelectorAll(".promo-radio") || []
            ).map((radio) => radio.value);
            const promoProductInCart = updatedCartData.items.find((item) =>
              promoProductIds.includes(String(item.id))
            );
  
            if (this.isBelowPromoThreshold(updatedCartData) && promoProductInCart) {
              console.log("Cart is below promo threshold, removing promo product.");
              removalUpdates[promoProductInCart.key] = 0;
            }

            const remainingCartItems = updatedCartData.items.filter(
              (item) => !removalUpdates.hasOwnProperty(item.key)
            );

            if (remainingCartItems.length === 1) {
              console.log(
                "One remaining item detected. Checking if it is the gift box."
              );
          
              if (remainingCartItems[0].product_id === this.giftBoxingProductId) {
                console.log("Gift box will be the only item left after removals, adding to updates.");
                removalUpdates[remainingCartItems[0].key] = 0;
                asyncOperations.push(this.clearGiftNote());
          
                // Log the updated removalUpdates object
                console.log("Updated removalUpdates with gift box removal:", removalUpdates);
              } else {
                console.log(
                  "The remaining item is not the gift box. Remaining item product ID:",
                  remainingCartItems[0].product_id
                );
              }
            } else {
              console.log(
                `Multiple items remain in the cart (${remainingCartItems.length}). No action taken for gift box.`
              );
            }
  
            if (Object.keys(removalUpdates).length > 0) {
              asyncOperations.push(
                this.additionalCartUpdates(removalUpdates)
                  .then(() => {
                    console.log("Additional cart updates completed successfully.");
                  })
                  .catch((error) => {
                    console.error("Error during additional cart updates:", error);
                  })
              );
            }
  
            await Promise.all(asyncOperations);
            await CartDrawer.render();
            disableLoading();
  
          } catch (error) {
            console.error("Error during CartItemQuantity flow:", error);
            disableLoading();
          }
        }
      });
    }
  
    async additionalCartUpdates(updates) {
      const body = JSON.stringify({ updates });
  
      console.log("Sending API request to update quantities:", updates);
  
      try {
        const response = await fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body,
        });
  
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
  
        const updatedCartData = await response.json();
        console.log("Cart updated successfully. New cart state:", updatedCartData);
  
        return updatedCartData;
      } catch (error) {
        console.error("Error updating cart quantities:", error);
        throw error;
      }
    }
  
    async clearGiftNote() {
      console.log("Clearing gift note.");
      return new Promise((resolve, reject) => {
        Shopify.getCart((cart) => {
          const note = "";
          Shopify.updateCartNote(note, (updatedCart) => {
            console.log("Gift note cleared. Updated cart note:", updatedCart.note);
            resolve(updatedCart);
          });
        });
      });
    }
  
    isBelowPromoThreshold(cartData) {
      const promoThresholdElement = document.getElementById("promo-threshold-converted");
      const promoThreshold = promoThresholdElement ? parseInt(promoThresholdElement.value, 10) : 0;
  
      let totalExcludingGiftCards = cartData.total_price;
      cartData.items.forEach((item) => {
        if (item.product_type === "Gift Card" || item.sku === "GFT100") {
          totalExcludingGiftCards -= item.price;
        }
      });
  
      const isBelowThreshold = totalExcludingGiftCards <= promoThreshold;
  
      console.log("Checking if cart is below promo threshold:");
      console.log("Promo threshold:", promoThreshold);
      console.log("Cart total:", cartData.total_price);
      console.log("Total excluding gift cards:", totalExcludingGiftCards);
      console.log("Is below threshold:", isBelowThreshold);
  
      return isBelowThreshold;
    }
  }
  
  customElements.define("cart-item-quantity", CartItemQuantity);

  class CartOverlay extends HTMLElement {
    constructor() {
      super();
      this.addEventListener("click", (event) => {
        event.preventDefault();
        Shopify.updateCartOnAdd();
        this.closest("cart-drawer").hide();
      });
    }
  }

  customElements.define("cart-overlay", CartOverlay);

  class CartClose extends HTMLElement {
    constructor() {
      super();
      this.addEventListener("click", (event) => {
        event.preventDefault();
        Shopify.updateCartOnAdd();
        this.closest("cart-drawer").hide();
      });
    }
  }

  customElements.define("cart-close", CartClose);


  function updateSubheadingMaxWidth() {
    const cartItems = document.querySelectorAll(".cart-item");
    cartItems.forEach(item => {
      const heading = item.querySelector(".cart-item-heading");
      const subheading = item.querySelector(".cart-item-subheading");
      if (heading && subheading) {
        const headingWidth = heading.getBoundingClientRect().width;
        const maxSubheadingWidth = headingWidth * 1.1;
        subheading.style.maxWidth = maxSubheadingWidth + "px";
      }
    });

  }

  updatePromoThreshold();
  updateShippingDescription();
  updateSubheadingMaxWidth();
  window.addEventListener('resize', updateSubheadingMaxWidth);  
  initializeSlickSlider();
});


